/**
 * Demo credentials for simple login gate
 * NOT for production use - just a demo login screen
 */
export const DEMO_CREDENTIALS = {
  users: [
    { username: 'adminagent', password: 'N0l!j', displayName: 'Admin Agent' },
  ],
};

export const validateCredentials = (username: string, password: string) => {
  const user = DEMO_CREDENTIALS.users.find(
    (u) => u.username === username && u.password === password
  );
  return user || null;
};
